import { Injectable } from '@angular/core';
import { CellExportFacade, ContentType, NotebookType } from '@mode/notebooks/contract';
import { Store } from '@ngrx/store';
import { CellExportActions } from '@mode/notebooks/contract';
import * as CellExportSelectors from './cell-export.selectors';
import * as LegacyNotebookSelectors from '../notebook/legacy-notebook.selectors';
import { combineLatest, map, Observable } from 'rxjs';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { fromDatasetResultSelectors } from '@mode/switch-views/domain';

@Injectable()
export class CellExportService implements CellExportFacade {
  public readonly isExporting$: Observable<boolean>;
  public readonly exportingCellToken$: Observable<string | null>;
  public readonly inProgressToastId$: Observable<number | null>;

  // rxStore selectors
  public readonly notebookToken$: Observable<string>;
  public readonly notebookSession$: Observable<any>;
  public readonly notebookState$: Observable<any>;
  public readonly notebookCellState$: Observable<any>;
  public readonly queries$: Observable<any>;
  public readonly selectedNotebookType$: Observable<NotebookType>;

  public readonly selectedCellToken$: Observable<string>;
  public readonly selectedCellContentType$: Observable<ContentType>;
  public readonly selectedCellIsExported$: Observable<boolean>;

  public readonly isPython$: Observable<boolean>;

  constructor(private store: Store) {
    this.isExporting$ = this.store.select(CellExportSelectors.isExporting);
    this.exportingCellToken$ = this.store.select(CellExportSelectors.exportingCellToken);
    this.inProgressToastId$ = this.store.select(CellExportSelectors.progressToastId);

    this.notebookToken$ = this.store.select(LegacyNotebookSelectors.notebookToken);
    this.notebookSession$ = this.store.select(LegacyNotebookSelectors.notebookSession);
    this.notebookState$ = this.store.select(LegacyNotebookSelectors.notebookState);
    this.notebookCellState$ = this.store.select(LegacyNotebookSelectors.notebookCellState);
    this.queries$ = this.store.select(LegacyNotebookSelectors.getQueries);
    this.selectedNotebookType$ = this.store.select(LegacyNotebookSelectors.selectedNotebookType);

    this.selectedCellToken$ = this.store.select(LegacyNotebookSelectors.selectedCellToken);
    this.selectedCellContentType$ = this.store.select(LegacyNotebookSelectors.selectedCellContentType);
    this.selectedCellIsExported$ = this.store.select(LegacyNotebookSelectors.selectedCellIsExported);

    this.isPython$ = combineLatest([this.selectedNotebookType$, this.selectedCellContentType$]).pipe(
      map(([notebookType, cellContentType]) => {
        return (
          (notebookType === NotebookType.Python3 ||
            notebookType === NotebookType.Python3Edge ||
            notebookType === NotebookType.Python3CleanSlate) &&
          cellContentType === ContentType.Python
        );
      })
    );
  }

  isExportingByCell$(cellToken: string) {
    return this.store.select(CellExportSelectors.isExportingByCellToken(cellToken));
  }

  getDatasetResultByCellToken(cellToken: string) {
    return this.store.select(fromDatasetResultSelectors.getDatasetResultByProducerToken(cellToken));
  }

  exportCell(cellToken: string, cellContentType: ContentType, datasetName: string): void {
    this.store.dispatch(
      CellExportActions.initExportCell({
        cellToken,
        cellContentType,
        datasetName,
      })
    );
  }

  getDatasetResults() {
    return this.store.select(fromDatasetResultSelectors.getDatasetResults);
  }
}
